var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"booking-validation",attrs:{"id":"page"}},[_c('booking-show',{attrs:{"is-validation":true,"validation-id":_vm.$route.params.uid,"is-unlogged":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }